import React, { useState, useEffect } from 'react';

import api from '../../api';

import './index.css';

const EmployeesList = (props) => {
  const [localEmployees, setLocalEmployees] = useState([]);

  useEffect(() => {
    !localEmployees.length && api.getUsersForAGivenJob(props.job.UUID).then(res => setLocalEmployees(res.data.data));
  }, []);

  return (
    <div className="employees-list">
      <h3 className="employees-list__title">Employees</h3>
      <p 
        className={
          props.searchTerm === 'whole team'
          ? "employees-list__whole-team employees-list__whole-team--active"
          : "employees-list__whole-team"
        }
        onClick={() => props.setSearchTerm({type: 'user', value: 'whole team'})}
      >
        Whole team
      </p>
      <ul className="employees-list__list">
        {localEmployees.map(emp => (
          <li 
            className={
              props.searchTerm === emp.UUID 
              ? "employees-list__item employees-list__item--active"
              : "employees-list__item"
            } 
            key={emp.UUID} 
          >
            <span 
              className="employees-list__user-name"
              onClick={() => props.setSearchTerm({type: 'user', value: emp.UUID})}
            >
              {emp.firstName + ' ' + emp.lastName}
            </span>
            <span 
              className="employees-list__view-profile"
              onClick={() => props.toggleEmployeeModal(emp)}
            >
              →View Profile
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default EmployeesList;